import { render, staticRenderFns } from "./SatisFaturalari.vue?vue&type=template&id=5e3eb85e&"
import script from "./SatisFaturalari.vue?vue&type=script&lang=js&"
export * from "./SatisFaturalari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports